<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="onSubmit">
		<v-textarea
			v-model="form.content"
			:error-messages="errors.collect('תוכן העדכון')"
			label="תוכן העדכון"
			required
		/>
		<!--		<smart-input :error="inputErrors.content" label='תוכן העדכון' v-model="form.content"></smart-input>-->
		<v-radio-group
			v-model="form.type"
			label="עדכונים רצים/ עדכונים עם תמונה"
		>
			<v-radio
				key="square"
				label="עדכונים עם תמונה"
				value="square"
			/>
			<v-radio
				key="run"
				label="עדכונים רצים"
				value="run"
			/>
		</v-radio-group>
		<smart-input
			v-model="form.link"
			:error="inputErrors.link"
			label="קישור"
		/>

		<img
			v-if="form.type == 'square' && form.id"
			class="image-preview"
			:src="form.img"
		>
		<v-file-input
			v-if="form.type == 'square'"
			:error="inputErrors.img"
			label="תמונה"
			name="img"
			accept="image/*"
			placeholder="תמונה"
		/>
		<v-switch
			v-model="form.active"
			:label="form.active? 'מוצג':'לא מוצג'"
		/>
		<div class="form-group">
			<v-btn
				type="submit"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import UpdateModule from "src/store/modules/Update.module";
import FormView from "src/mixins/FormView";

export default {
	name: "UpdateForm",
	components: {},
	props: [],
	data () {
		return {
			form: {
				content: "gdfgd",
				type: "square",
			},
		};
	},
	mixins: [new FormView(UpdateModule, "update", true)],
	computed: {
		isNew () {
			return !!this.update.id;
		},
	},
	methods:
		{
			beforeSubmit (formData) {
				const data = Object.assign({}, this.form);
				formData.append("update", JSON.stringify(data));
				return formData;
			},
		},
};
</script>

<style>
	.image-preview {
		max-width: 75px;
	}
</style>
